import axios from 'axios';

var basetest = "https://baknd.bangbangrobotics.com";

export const GetRoleslist = params => {
  return axios.get(`${basetest}/roles`, {params: params});
};

export const GetPermissionslist = params => {
  return axios.get(`${basetest}/roles/permissions`, {params: params});
};

export const reqLogin = params => {
  return axios.post(`${basetest}/users/login`, params).then(res => res.data)
};

export const GetUserslist = params => {
  return axios.get(`${basetest}/users`, {params: params});
};

export const GetUsersDetail = params => {
  return axios.get(`${basetest}/questionnaires`, {params: params});
};


export const GetReservationlist = params => {
  return axios.get(`${basetest}/reservations`, {params: params});
};

export const GetFeedbacklist = params => {
  return axios.get(`${basetest}/feedbacks`, {params: params});
};

export const GetDealerlist = params => {
  return axios.get(`${basetest}/dealers`, {params: params});
};

export const GetDevicelist = params => {
  return axios.get(`${basetest}/devices`, {params: params});
};

export const GetBetweenlist = params => {
  return axios.get(`${basetest}/summaries`, {params: params});
};

export const GetSportlist = params => {
  return axios.get(`${basetest}/sport-summaries`, {params: params});
};

export const GetErrlist = params => {
  return axios.get(`${basetest}/error-data`, {params: params});
};

export const GetSportErrlist = params => {
  return axios.get(`${basetest}/sport-error-data`, {params: params});
};

export const GetDevDetail = params => {
  return axios.get(`${basetest}/detaileds`, {params: params});
};

export const GetSportDevDetail = params => {
  return axios.get(`${basetest}/sport-details`, {params: params});
};

export const GetSportDevDetail2 = params => {
  return axios.get(`${basetest}/sport-detaileds`, {params: params});
};

export const GetUserlist = params => {
  return axios.get(`${basetest}/userinfos`, {params: params});
};

export const GetInvoicelist = params => {
  return axios.get(`${basetest}/invoices`, {params: params});
};

export const GetTasklist = params => {
  return axios.get(`${basetest}/tasks`, {params: params});
};

export const GetStoragelist = params => {
  return axios.get(`${basetest}/nonwarehouseds`, {params: params});
};

export const GetWarehouslist = params => {
  return axios.get(`${basetest}/warehouseds`, {params: params});
};

export const GetDeliverlist = params => {
  return axios.get(`${basetest}/delivereds`, {params: params});
};

export const GetUnreservationlistlist = params => {
  return axios.get(`${basetest}/unallocatedreservations`, {params: params});
};

export const GetAllocatedlist = params => {
  return axios.get(`${basetest}/allocatedreservations`, {params: params});
};

export const GetDelreserlist = params => {
  return axios.get(`${basetest}/deletedreservations`, {params: params});
};

export const GetDevdataslist = params => {
  return axios.get(`${basetest}/dev-data`, {params: params});
};

export const GetDevSportdataslist = params => {
  return axios.get(`${basetest}/dev-sport-data`, {params: params});
};

export const GetDevWheelChairdataslist = params => {
  return axios.get(`${basetest}/dev-ewc-raw-logs`, {params: params});
};

export const GetDevdatatestslist = params => {
  return axios.get(`${basetest}/dev-test-data`, {params: params});
};

export const GetDevlogslist = params => {
  return axios.get(`${basetest}/dev-logs`, {params: params});
};

export const GetDevSportlogslist = params => {
  return axios.get(`${basetest}/dev-sport-logs`, {params: params});
};

export const GetDevWheelChairlogslist = params => {
  return axios.get(`${basetest}/dev-ewc-realtime-logs`, {params: params});
};

export const GetDevSportErrlist = params => {
  return axios.get(`${basetest}/dev-sport-error-logs`, {params: params});
};

export const GetDevWheelChairErrlist = params => {
  return axios.get(`${basetest}/dev-ewc-error-logs`, {params: params});
};

export const GetDevflashlogslist = params => {
  return axios.get(`${basetest}/dev-flash-logs`, {params: params});
};

export const GetDevSportflashlogslist = params => {
  return axios.get(`${basetest}/dev-sport-flash-logs`, {params: params});
};

export const GetDevWheelChairflashlogslist = params => {
  return axios.get(`${basetest}/dev-ewc-flash-logs`, {params: params});
};

export const GetDelfeedbackslist = params => {
  return axios.get(`${basetest}/deletedfeedbacks`, {params: params});
};

export const GetGprsStatuslist = params => {
  return axios.get(`${basetest}/nonwarehouseds/gprsStatus`, {params: params});
};

export const GetDeleteddealerslist = params => {
  return axios.get(`${basetest}/deleteddealers`, {params: params});
};

export const GetActiveUserlist = params => {
  return axios.get(`${basetest}/exhibition1-targets`, {params: params});
};

export const GetCandidate = params => {
  return axios.get(`${basetest}/candidates`, {params: params});
};

export const GetAfterInfo = params => {
  return axios.get(`${basetest}/v2/device-info`, {params: params});
};

export const GetMobileAppUserList = params => {
  return axios.get(`${basetest}/members`, {params: params})
};

export const GetDeviceStatusList = params => {
  return axios.get(`${basetest}/device-summaries`, {params: params});
};

export const MarkDeviceRecords = (token, params) => {
  return axios.put(`${basetest}/device-summaries/mark-record?token=${token}`, params);
};

export const OpenOrCloseGameOfMobileAppUser = (token, userid, params) => {
  return axios.put(`${basetest}/members/${userid}/game-permission?token=${token}`, params)
};

export const GetOverviewInfo = params => {
  return axios.get(`${basetest}/data/summary`, {params: params});
};

export const GetNewOnlineDeviceInfo = params => {
  return axios.get(`${basetest}/data/new-online`, {params: params});
};

export const GetActiveDeviceInfo = params => {
  return axios.get(`${basetest}/data/active-device`, {params: params});
};

export const GetActivePeriodInfo = params => {
  return axios.get(`${basetest}/data/active-device/stat`, {params: params});
};

export const GetOnlineDurationInfo = params => {
  return axios.get(`${basetest}/data/online-condition`, {params: params});
};

export const GetDeviceStatusOverviewList = params => {
  return axios.get(`${basetest}/data/device`, {params: params});
}

export const GetDeviceStatusDetailsList = (device_name, params) => {
  return axios.get(`${basetest}/data/details/${device_name}`, {params: params});
}

export const GetDeviceStatusErrorLogList = (device_name, params) => {
  return axios.get(`${basetest}/data/invalid-format-data/${device_name}`, {params: params});
}

export const GetWheelDeviceStatusDetailsList = (device_name, params) => {
  return axios.get(`${basetest}/data/chair/details/${device_name}`, {params: params})
}

export const RefundDevice = (token, did, params) => {
  return axios.put(`${basetest}/delivereds/${did}/deliverstatus?token=${token}`, params);
};


// WEBPACK FOOTER //
// ./src/api/api.js